// lookup for the option/labels for our datamodel.datamodel_type
export const datamodelTypeLookup = {
  blog_custom_fields: 'Custom fields - Blog post',
  datamodel_item: 'Content database item fields',
  location_custom_fields: 'Custom fields - Location',
  page_custom_fields: 'Custom fields - Page',
  related_datamodel: 'Related/repeating data model',
  site_custom_fields: 'Custom fields - Site',
  templatecomponent_fields: 'Template component fields',
  menu_item_custom_fields: 'Menu item custom fields',
};
// datamodel field types
export const fieldTypeLookup = {
  boolean: 'Boolean (Toggle)',
  date_picker: 'Date picker',
  datetime_picker: 'Date and time picker',
  datamodel_item: 'Content database item',
  html: 'HTML',
  image: 'Image upload',
  image_select: 'Image select',
  //'item_list': 'Item list',  // WIP field type with issues that need to be addressed
  long_text: 'Long text',
  multi_line_text: 'Multi-line text',
  number: 'Number / digits',
  related_model_list: 'Related/repeating data model list',
  rgba_color: 'Color picker',
  select: 'Select dropdown',
  short_text: 'Short text',
  simple_html: 'Simple HTML',
  slug: 'Slug',
  url: 'URL/link',
  stepper: 'Stepper',
  blog_post_select: 'Blog post select',
  address_autocomplete: 'Address autocomplete',
  datamodel_sub_type: 'Datamodel sub type',
  item_list: 'Item list',
};
// page types that do not render, so we don't need to show a path in UI
export const nonRenderingPageTypes = ['custom404', 'template'];
// lookup for the labels for page.type
export const pageTypeLookup = {
  blog: 'Blog root page',
  custom404: 'Custom 404 page',
  default: 'Normal page',
  directory: 'Location directory root page',
  sitesearch: 'Site search root page',
  subpath: 'Subpath page',
  template: 'Page template (Parent)',
  template_page: 'Templated page',
};
export const pageTypeTooltipLookup = {
  auto: 'Special auto listings page type',
  blog: 'Special blog page type that generates subpages for blog posts and categories.',
  custom404: 'Page template that is shown if a page/URL requested is 404.',
  default:
    'Normal pages are built with template components or custom HTML modules',
  directory:
    'Special Location directory page type that generates state and city subpages',
  sitesearch: 'Special Website site search results page',
  subpath: 'Advanced custom HTML page with dynamic URL paths',
  template:
    'Page templates are used to create multiple pages using the same layout',
  template_page: 'Page built with a Page template',
};

// extended valid elements for tinymce
//
// supporting <script> tags
// supporting <svg> and elements within
export const tinymceExtendedValidElements = [
  'a[*]',
  'altGlyph[*]',
  'altGlyphDef[*]',
  'altGlyphItem[*]',
  'animate[*]',
  'animateColor[*]',
  'animateMotion[*]',
  'animateTransform[*]',
  'circle[*]',
  'clipPath[*]',
  'color-profile[*]',
  'cursor[*]',
  'defs[*]',
  'desc[*]',
  'discard[*]',
  'ellipse[*]',
  'feBlend[*]',
  'feColorMatrix[*]',
  'feComponentTransfer[*]',
  'feComposite[*]',
  'feConvolveMatrix[*]',
  'feDiffuseLighting[*]',
  'feDisplacementMap[*]',
  'feDistantLight[*]',
  'feDropShadow[*]',
  'feFlood[*]',
  'feFuncA[*]',
  'feFuncB[*]',
  'feFuncG[*]',
  'feFuncR[*]',
  'feGaussianBlur[*]',
  'feImage[*]',
  'feMerge[*]',
  'feMergeNode[*]',
  'feMorphology[*]',
  'feOffset[*]',
  'fePointLight[*]',
  'feSpecularLighting[*]',
  'feSpotLight[*]',
  'feTile[*]',
  'feTurbulence[*]',
  'filter[*]',
  'font-face-format[*]',
  'font-face-name[*]',
  'font-face-src[*]',
  'font-face-uri[*]',
  'font-face[*]',
  'font[*]',
  'foreignObject[*]',
  'g[*]',
  'glyph[*]',
  'glyphRef[*]',
  'hatch[*]',
  'hatchpath[*]',
  'hkern[*]',
  'image[*]',
  'line[*]',
  'linearGradient[*]',
  'marker[*]',
  'mask[*]',
  'metadata[*]',
  'missing-glyph[*]',
  'mpath[*]',
  'path[*]',
  'pattern[*]',
  'polygon[*]',
  'polyline[*]',
  'radialGradient[*]',
  'rect[*]',
  'script[*]',
  'set[*]',
  'solidcolor[*]',
  'stop[*]',
  'style[*]',
  'svg[*]',
  'switch[*]',
  'symbol[*]',
  'text[*]',
  'textPath[*]',
  'title[*]',
  'tref[*]',
  'tspan[*]',
  'use[*]',
  'view[*]',
  'vkern[*]',
];

export const FETCH_STATUS = {
  IDLE: 'idle',
  PAUSED: 'paused',
  FETCHING: 'fetching',
};
